import type { CloudRetailProductDetail } from './trackSearchResults';

type HitLike = {
  sku?: string;
  skus?: Array<string | number>;
  product?: { id?: string | number };
  objectID?: string | number;
};

/**
 * Extracts a Google Retail product id from an Algolia hit.
 */
export const toCloudRetailProductDetail = (hit: HitLike): CloudRetailProductDetail => ({
  product: { id: (hit.skus?.length ? String(hit.skus[0]) : '') || hit.sku || String(hit.product?.id || hit.objectID) },
});
